const {cxt} = require("./context");

const dob = [
  'date'
];

const dobRequired = [
  'required',
  'date'
];

const isAdult = [
  'required',
  'date',
  cxt('older-than', { olderThan: 18 })
];

module.exports = {
  dob,
  dobRequired,
  isAdult,
};